import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICONS } from '../../icons';
import { useAuth } from '../../contexts/AuthContext';

export default function SidebarProfileHeader({ userData = {}, collapsed = false, isActive = false, onProfileClick }) {
  const { currentUser } = useAuth();
  const username = userData.username || currentUser?.displayName || 'Player';

  if (collapsed) {
    return (
      <button
        className={`sp-header collapsed-header sp-header-btn ${isActive ? 'active' : ''}`}
        onClick={onProfileClick}
        title="Profile"
      >
        {userData.profileImageUrl ? (
          <img src={userData.profileImageUrl} alt="" className="sp-avatar-sm" />
        ) : (
          <div className="sp-avatar-sm sp-avatar-fallback">{username.charAt(0).toUpperCase()}</div>
        )}
      </button>
    );
  }

  return (
    <button
      className={`sp-header sp-header-btn ${isActive ? 'active' : ''}`}
      onClick={onProfileClick}
    >
      <div className="sp-ring-section">
        {userData.profileImageUrl ? (
          <img src={userData.profileImageUrl} alt="" className="sp-avatar" />
        ) : (
          <div className="sp-avatar sp-avatar-fallback">{username.charAt(0).toUpperCase()}</div>
        )}
        <div className="sp-ring-info">
          <span className="sp-username">{username}</span>
          <span className="sp-email">{currentUser?.email}</span>
        </div>
        <FontAwesomeIcon icon={ICONS.CHEVRON_RIGHT} className="sp-profile-arrow" />
      </div>
    </button>
  );
}
